<script>
import { mapActions } from "vuex";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import Loader from "@/components/widgets/loader";
import AlertError from '@/components/alert_error'

export default {
  page: {
    title: "مركز العمل التطوعي",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Loader,
    AlertError
  },
  data() {
    return {
      username: "",
      password: "",
      remember: false,
      errors: [],
      submitted: false,
      tryingToLogIn: false,
      loadingButton: false,
      loading: false,

      appMode: process.env.VUE_APP_MODE,
    };
  },
  validations: {
    username: {required, minLength: minLength(3), maxLength: maxLength(30)},
    password: {required, minLength: minLength(8), maxLength: maxLength(50)},
  },
  methods: {
    ...mapActions('auth', ['logIn']),
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    tryToLogIn() {
      this.errors = []
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid)  return;

      this.loadingButton = true;
      this.logIn({
        username: this.username,
        password: this.password,
        remember: this.remember,
      })
      .then(() => {
        this.loading = false
        this.loadingButton = false;
        alert('push route ');
        // Redirect to the originally requested page, or to the home page
        this.$router.push({ name: "statistics" })
      })
      .catch((error) => {
        this.loading = false
        this.loadingButton = false
        this.handleError(error)
      })
    },
    testLogin(e){
      this.loading = true
      this.username = e.target.getAttribute('username')
      this.password = e.target.getAttribute('password')
      this.tryToLogIn()
    }
  }
};
</script>

<template>
  <!-- <Layout> -->
    
    <div class="account-pages my-5 pt-5">
        <div class="container">

          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
              <div class="card overflow-hidden">
                <div class="bg-soft-primary">
                  <div class="row">
                    <div class="col-12">
                       <div class="p-4">
                        <h5 style="font-size: 16px;" class="text-center"> مركز العمل التطوعي </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0">

                  <div class="p-2 mb-3 text-center">
                    <img src="@/assets/images/logo.png" alt="logo" width="65" />
                  </div>

                  <Loader :loading="loading">
                    <b-form class="p-2" @submit.prevent="tryToLogIn" >

                      <AlertError :errors="errors" />

                      <!-- Test Users in dev mode -->
                      <b-form-group v-if="this.appMode == 'devloper'" id="input-group-test" label="تسجيل الدخول التجريبي">

                        <b-button type="button" variant="danger" class="col-12 mt-3"
                          username="super_admin"
                          password="password"
                          @click="testLogin"
                        > مدير رئيسي</b-button>

                        <b-button type="button" variant="info" class="col-12 mt-3 mb-5"
                          username="editor1"
                          password="password"
                          @click="testLogin"
                        > محرر الموقع</b-button>
                      </b-form-group>


                      <b-form-group class="col-md-12 mb-3" id="input-group-1" label="اسم المستخدم" label-for="input-1">
                        <b-form-input id="input-1" type="text" v-model="username" placeholder="ادخل اسم المستخدم" :class="{ 'is-invalid': submitted && $v.username.$error }"></b-form-input>
                        <div v-if="submitted && $v.username.$error" class="invalid-feedback">
                          <span v-if="!$v.username.required">هذا الحقل اجباري</span>
                          <span v-if="!$v.username.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 3 احرف على الاقل . </span>
                          <span v-if="!$v.username.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 30 حرف على الاكثر . </span>
                        </div>
                      </b-form-group>

                      <b-form-group class="col-md-12 mb-3" id="input-group-2" label="كلمة المرور" label-for="input-2">
                        <b-form-input id="input-2" type="password" v-model="password" placeholder="ادخل كلمة المرور" :class="{ 'is-invalid': submitted && $v.password.$error }"></b-form-input>
                        <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                          <span v-if="!$v.password.required">هذا الحقل اجباري</span>
                          <span v-if="!$v.password.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 8 احرف على الاقل . </span>
                          <span v-if="!$v.password.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 50 حرف على الاكثر . </span>
                        </div>
                      </b-form-group>

                      <div class="col-md-12">
                          <b-form-checkbox id="customControlInline" v-model="remember" class="mb-1" plain >تذكرني</b-form-checkbox>
                      </div>

                      <div class="col-md-12 mt-3">
                        <b-button type="submit" :disabled="loadingButton" variant="primary" class="col-12">
                          <span v-if="!loadingButton">تسجيل دخول</span>
                          <b-spinner v-else small></b-spinner>
                        </b-button>
                      </div>
                      
                    </b-form>
                  </Loader>

                </div>
                <!-- end card-body -->
              </div>
              <!-- end card -->

            
              <!-- end row -->
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->

      </div>
    </div>
  <!-- </Layout> -->
</template>

<style lang="scss" module></style>
